@if (state$ | async; as state) {
  @if (state.visible) {
    <app-floating-ai-button
      [isGlobalInstance]="true"
      [companyId]="state.companyId"
      [defaultTab]="state.defaultTab"
      [operationId]="state.operationId"
      [disablePositionStorage]="state.disablePositionStorage"></app-floating-ai-button>
  }
}
